import React from "react";
import "../styles/WhyUs.scss";

const FEATURES = [
  {
    title: "Experiencia y Maestría",
    text:
      "Con más de una década en el desarrollo web, hemos perfeccionado la creación de aplicaciones y páginas. Nuestro equipo experto garantiza resultados excepcionales en cada proyecto, ya sea para startups o negocios establecidos.",
    icon: "orbit",
  },
  {
    title: "Calidad Garantizada",
    text:
      "Utilizamos las tecnologías que mejor se adaptan a tu proyecto para asegurar resultados excepcionales. Ofrecemos una garantía en todos nuestros desarrollos para tu tranquilidad y satisfacción.",
    icon: "shield",
  },
  {
    title: "Precios justos",
    text:
      "Ofrecemos precios justos y acordes al valor que entregamos. Creemos en la transparencia y en brindar soluciones accesibles sin sacrificar calidad. Tu inversión está respaldada por resultados reales.",
    icon: "tag",
  },
  {
    title: "Servicio Integral",
    text:
      "Más que un proveedor, somos tu socio en cada proyecto. Ofrecemos un servicio integral que abarca desde el diseño y desarrollo hasta la implementación de aplicaciones web, páginas, landing pages y más.",
    icon: "layers",
  },
  {
    title: "Compromiso con el Cliente",
    text:
      "Nuestra prioridad es tu satisfacción. Nos esforzamos por brindarte un servicio excepcional y una experiencia positiva en cada proyecto. Tu confianza es nuestro mayor activo.",
    icon: "spark",
  },
];

function Icon({ name }) {
  // Íconos minimalistas en SVG (sin librerías)
  switch (name) {
    case "shield":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2l8 4v6c0 5-3.4 9.4-8 10-4.6-.6-8-5-8-10V6l8-4zm0 3.2L6 8v4c0 3.8 2.3 7.1 6 7.7 3.7-.6 6-3.9 6-7.7V8l-6-2.8z" />
        </svg>
      );
    case "tag":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.6 13.3l-7.3 7.3c-.4.4-1 .4-1.4 0L3 11.7V3h8.7l8.9 8.9c.4.4.4 1 0 1.4zM7.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
        </svg>
      );
    case "layers":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2l10 6-10 6L2 8l10-6zm0 13l10-6v3l-10 6-10-6V9l10 6zm0 6l10-6v3l-10 6-10-6v-3l10 6z" />
        </svg>
      );
    case "spark":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2l1.6 6.2L20 10l-6.4 1.8L12 18l-1.6-6.2L4 10l6.4-1.8L12 2zm8 12l.8 3.1L24 18l-3.2.9L20 22l-.8-3.1L16 18l3.2-.9L20 14z" />
        </svg>
      );
    case "orbit":
    default:
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 5.2c4.7 0 8.5 2.9 8.5 6.8s-3.8 6.8-8.5 6.8S3.5 15.9 3.5 12 7.3 5.2 12 5.2zm0 2C8.4 7.2 5.5 9.3 5.5 12s2.9 4.8 6.5 4.8 6.5-2.1 6.5-4.8-2.9-4.8-6.5-4.8z" />
          <path d="M12 2c1.6 0 3.1 1.3 4.1 3.4 1.1 2.4 1.4 5.3.9 8.1-.5 2.8-1.8 5.2-3.4 6.7-1.5 1.4-3 1.7-4.2 1-1.2-.7-2-2.2-2.3-4.1-.3-2 .1-4.4 1.1-6.9 1.7-4.2 4-8.2 4-8.2l1.1.6s-2.3 4-3.9 8c-.9 2.2-1.3 4.2-1 5.9.2 1.4.8 2.4 1.6 2.8.8.4 1.7.1 2.7-.8 1.3-1.2 2.3-3.3 2.7-5.7.4-2.5.1-5.1-.8-7.2C14.3 4.1 13.1 3 12 3V2z" />
        </svg>
      );
  }
}

export default function WhyUs({ className = "" }) {
  return (
    <section className={`ovit-whyus ${className}`} aria-labelledby="ovit-whyus-title" id="whyUs">
      <div className="ovit-whyus__bg" aria-hidden="true">
        <div className="ovit-whyus__grid" />
        <div className="ovit-whyus__orb ovit-whyus__orb--a" />
        <div className="ovit-whyus__orb ovit-whyus__orb--b" />
        <div className="ovit-whyus__scanline" />
      </div>

      <div className="ovit-whyus__container">
        <header className="ovit-whyus__header">
          <div className="ovit-whyus__badge">
            <span className="ovit-whyus__dot" aria-hidden="true" />
            OVIT Soluciones Web
          </div>

          <h2 className="ovit-whyus__title" id="ovit-whyus-title">
            Desarrollo web moderno, <span>con resultados</span> que se notan
          </h2>

          <p className="ovit-whyus__subtitle">
            Creamos páginas, landing pages y aplicaciones con un estándar visual y técnico alto:
            diseño limpio, velocidad, estructura profesional y enfoque en conversión.
          </p>
        </header>

        <div className="ovit-whyus__cards">
          {FEATURES.map((f) => (
            <article className="ovit-whyus__card" key={f.title}>
              <div className="ovit-whyus__cardGlow" aria-hidden="true" />
              <div className="ovit-whyus__cardTop">
                <div className="ovit-whyus__iconWrap" aria-hidden="true">
                  <Icon name={f.icon} />
                </div>
                <h3 className="ovit-whyus__cardTitle">{f.title}</h3>
              </div>

              <p className="ovit-whyus__cardText">{f.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
